import type { RefObject } from 'react';
import { useLayoutEffect } from 'react';
import { useScrollProviderContext } from 'components/unlisted/ScrollProvider';
import { createScrollTrigger } from '@/util/scroll/scrollTrigger.utils';

function useClipBlockOverflow(elementRef: RefObject<HTMLElement | null>): void {
  const scrollContext = useScrollProviderContext();

  useLayoutEffect(() => {
    const triggerElement = elementRef.current;

    if (!triggerElement) return undefined;

    // If not solved by main {overflow-block: clip} could maybe be fixed with a
    // translating window following the viewport with a overflow-block
    const clipBlockOverflow = (): void => {
      triggerElement.style.setProperty('overflow-block', 'clip');
    };

    const clearBlockOverflow = (): void => {
      triggerElement.style.removeProperty('overflow-block');
    };

    const scrollTrigger = createScrollTrigger(triggerElement, undefined, {
      scroller: scrollContext?.hasSmoothScroll?.current
        ? scrollContext?.scrollWrapperRef?.current || undefined
        : undefined,
      start: 'top-=1px top',
      end: '30%',
      onEnter: () => {
        console.log('enter');
        clearBlockOverflow();
      },
      onLeave: () => {
        console.log('leave');
        clipBlockOverflow();
      },
      onEnterBack: () => {
        console.log('onEnterBack');
        clearBlockOverflow();
      },
      onLeaveBack: () => {
        console.log('onLeaveBack');
        clipBlockOverflow();
      },
    });

    if (scrollTrigger.isActive || scrollTrigger.progress === 1) {
      clearBlockOverflow();
    }

    return () => {
      scrollTrigger.kill();
    };
  }, [elementRef, scrollContext]);
}

export default useClipBlockOverflow;
